export default __webpack_public_path__ + "static/media/Instagram-dark.e0a9ec5d.svg";